/* @flow */
export interface IEventTarget {
    on(eventName: string, listener: Function): void;
    off(eventName: string, listener: Function): void;
    fireEvent(eventName: string, event: any): void
}
export class EventTarget implements IEventTarget {
    listeners: {[ string ]: Array<Function>};
    constructor () {
        this.listeners = {};
    }
    on (eventName: string, listener: Function) {
        let listeners = this.listeners[eventName];
        if (!listeners) {
            this.listeners[eventName] = [listener];
        } else {
            const index = listeners.indexOf(listener);
            if (index < 0) {
                listeners.push(listener);
            } else {
                console.warn('Try add same listener twice');
            }
        }
    }
    off (eventName: string, listener: Function) {
        const listeners = this.listeners[eventName];
        if (listeners) {
            const index = listeners.indexOf(listener);
            if (index > -1) {
                listeners.splice(index, 1);
                return;
            }
        }
        console.warn('Try remove not existing listener');
    }
    fireEvent (eventName: string, event: any) {
        const listeners = this.listeners[eventName];
        if (listeners) {
            for (let i = listeners.length - 1; i >= 0; i--) {
                const listener = listeners[i];
                listener(event);
            }
        }
    }
}
